


import React, { useEffect } from "react";

export default function BookingForm({ open, onClose, testName }) {
  const [name, setName] = React.useState("");
  const [contact, setContact] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [date, setDate] = React.useState("");

  useEffect(() => {
    if (open) {
      const today = new Date().toISOString().split("T")[0];
      setDate(today);
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = () => {
    if (contact.length !== 10) {
      alert("Please enter a valid 10-digit contact number");
      return;
    }

    const msg =
      `New Booking Request:\n` +
      `Test/Package: ${testName}\n` +
      `Patient Name: ${name}\n` +
      `Contact: ${contact}\n` +
      `Address: ${address}\n` +
      `Preferred Date: ${date}`;

    window.open(
      `https://wa.me/7507630030?text=${encodeURIComponent(msg)}`,
      "_blank"
    );

    setName("");
    setContact("");
    setAddress("");
    const today = new Date().toISOString().split("T")[0];
    setDate(today);

    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-2xl shadow-2xl w-80 border-2 border-red-500">
        
        <h2 className="text-2xl font-bold text-red-600 mb-4 text-center">
          Book Test / Package
        </h2>

        <label className="text-sm font-semibold text-gray-700">Selected Test</label>
        <input
          value={testName}
          readOnly
          className="bg-gray-100 p-2 w-full rounded mb-3 border border-gray-300 shadow-sm"
        />

        <label className="text-sm font-semibold text-gray-700">Patient Name</label>
        <input
          className="border p-2 w-full rounded mb-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-red-400"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <label className="text-sm font-semibold text-gray-700">Contact</label>
        <input
          className="border p-2 w-full rounded mb-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-red-400"
          value={contact}
          maxLength="10"
          onChange={(e) => setContact(e.target.value.replace(/\D/g, ""))}
        />

        <label className="text-sm font-semibold text-gray-700">Address</label>
        <textarea
          className="border p-2 w-full rounded mb-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-red-400"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />

        <label className="text-sm font-semibold text-gray-700">Preferred Date</label>
        <input
          type="date"
          className="border p-2 w-full rounded mb-4 shadow-sm focus:outline-none focus:ring-2 focus:ring-red-400"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />

        <div className="flex justify-between mt-3">
          <button
            className="bg-gray-300 text-black px-4 py-2 rounded-lg hover:bg-gray-400 transition"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="bg-red-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-700 transition"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
